var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_17763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5C3.89 2 3 2.9 3 4V18C3 19.1 3.9 20 5 20H9L11.29 22.29C11.68 22.68 12.31 22.68 12.7 22.29L15 20H19C20.1 20 21 19.1 21 18V4C21 2.9 20.1 2 19 2ZM13 18H11V16H13V18ZM15.07 10.25L14.17 11.17C13.59 11.76 13.18 12.27 13.05 13.23C12.99 13.66 12.64 13.99 12.2 13.99H11.89C11.37 13.99 10.97 13.53 11.04 13.01C11.15 12.1 11.57 11.29 12.18 10.67L13.42 9.41C13.78 9.05 14 8.55 14 8C14 6.9 13.1 6 12 6C11.13 6 10.38 6.57 10.11 7.35C9.98 7.72 9.67 7.99 9.28 7.99H8.98C8.4 7.99 8 7.43 8.16 6.87C8.65 5.21 10.18 4 12 4C14.21 4 16 5.79 16 8C16 8.88 15.64 9.68 15.07 10.25Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_17763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBalloon);
export default __webpack_public_path__ + "static/media/HelpBalloon.eb792618d0874c0cb9ce6a6e0fe680a9.svg";
export { ForwardRef as ReactComponent };